import React, { Component } from 'react';
import {
  Modal,
  Segment,
  Header,
  Button,
  List,
  Form,
} from 'semantic-ui-react';
import { graphql, compose } from 'react-apollo';
import { Analytics } from 'aws-amplify';
import { LINKS_PER_PAGE } from '../constants';
import QueryAllSubscribers from '../graphql/QueryAllSubscribers';
import MutationDeleteSubscriber from '../graphql/MutationDeleteSubscriber';
import MutationEditSubscriber from '../graphql/MutationEditSubscriber';
import SubscriberEntry from './SubscriberEntry';

class ListSubscribers extends Component {
  static defaultProps = {
    subscribers: [],
    deleteSubscriber: () => null,
  };

  state = {
    editModalOpen: false,
    deleteModalOpen: false,
    selectedSubscriber: {
      id: '',
      email: '',
      status: '',
      createdAt: '',
      notified: '',
    },
    subscriberToUpdate: {
      id: '',
      email: '',
      status: '',
      createdAt: '',
      notified: '',
    },
  };

  showDeleteModal = subscriber =>
    this.setState({
      selectedSubscriber: subscriber,
      deleteModalOpen: true,
    });
  closeDeleteModal = subscriber =>
    this.setState({
      selectedSubscriber: subscriber,
      deleteModalOpen: false,
    });
  showEditModal = subscriber =>
    this.setState({
      selectedSubscriber: subscriber,
      subscriberToUpdate: subscriber,
      editModalOpen: true,
    });
  closeEditModal = subscriber =>
    this.setState({
      selectedSubscriber: subscriber,
      editModalOpen: false,
    });

  handleEmailChange = e => {
    const { selectedSubscriber } = this.state;
    this.setState({
      subscriberToUpdate: {
        id: selectedSubscriber.id,
        email: e.target.value,
        status: selectedSubscriber.status,
        notified: selectedSubscriber.notified,
        createdAt: selectedSubscriber.createdAt,
      },
    });
  };

  handleUpdateSubscriber = async e => {
    e.preventDefault();
    const { updateSubscriber } = this.props;
    const { subscriberToUpdate, selectedSubscriber } = this.state;

    await updateSubscriber(subscriberToUpdate);
    this.setState({
      subscriberToUpdate: {
        id: '',
        email: '',
        status: '',
        createdAt: '',
        notified: '',
      },
    });
    Analytics.record('Subscriber-Update');
    this.closeEditModal(selectedSubscriber);
  };

  async handleDeleteClick(subscriber, e) {
    e.preventDefault();
    const { setResultsPage } = this.props;
    const { deleteSubscriber } = this.props;

    await deleteSubscriber(subscriber);
    Analytics.record('Subscriber-Deleted');
    this.closeDeleteModal(subscriber);
    setResultsPage('0');
    setTimeout(function() {
      setResultsPage('1');
    }, 1000);
  }

  render() {
    const { subscribers, page, nextToken, setResultsPage } = this.props;
    const { selectedSubscriber } = this.state;
    const pageNumber = parseInt(page, 10);
    const nextPage = (pageNumber + 1).toString();
    const prevPage = (pageNumber - 1).toString();
    if (subscribers.length === 0 && pageNumber > 1) {
      setTimeout(function() {
        setResultsPage('1');
      }, 1000);
    }

    return (
      <div>
        <Header as="h3">
          Recent Subscribers - Page {page === '0' ? 'Loading' : page}
        </Header>
        <List divided relaxed>
          {[]
            .concat(subscribers)
            .sort((b, a) => a.createdAt.localeCompare(b.createdAt))
            .map(subscriber => (
              <SubscriberEntry
                key={subscriber.id}
                subscriber={subscriber}
                showDeleteModal={this.showDeleteModal}
                showEditModal={this.showEditModal}
              />
            ))}
        </List>
        <Segment floated="right">
          <Button
            disabled={pageNumber === 1}
            content="First"
            icon="home"
            labelPosition="left"
            onClick={() => {
              setResultsPage('1');
            }}
          />
          <Button
            disabled={pageNumber < 2}
            content="Previous"
            icon="left arrow"
            labelPosition="left"
            onClick={() => {
              setResultsPage(prevPage);
            }}
          />
          <Button
            disabled={nextToken === null}
            content="Next"
            icon="right arrow"
            labelPosition="right"
            onClick={() => {
              setResultsPage(nextPage, nextToken);
            }}
          />
        </Segment>
        <Modal
          size="tiny"
          open={this.state.deleteModalOpen}
          onClose={this.closeDeleteModal}
          subscriber={selectedSubscriber}
        >
          <Modal.Header content="Delete Subscriber" />
          <Modal.Content>
            <p>Are you sure you want to delete {selectedSubscriber.email}?</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              negative
              content="No"
              onClick={this.closeDeleteModal.bind(this, selectedSubscriber)}
            />
            <Button
              positive
              content="Yes"
              icon="checkmark"
              labelPosition="right"
              onClick={this.handleDeleteClick.bind(this, selectedSubscriber)}
            />
          </Modal.Actions>
        </Modal>
        <Modal
          size="tiny"
          open={this.state.editModalOpen}
          onClose={this.closeEditModal}
          subscriber={selectedSubscriber}
        >
          <Modal.Header content="Edit Subscriber" />
          <Modal.Content>
            <p>Edit the email address: {selectedSubscriber.email}?</p>
            <Form onSubmit={this.handleUpdateSubscriber}>
              <Form.Input
                fluid
                action="Update"
                value={this.state.subscriberToUpdate.email}
                name="email"
                onChange={this.handleEmailChange}
                label="Email address"
                placeholder={selectedSubscriber.email}
                type="email"
              />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              negative
              content="Cancel"
              onClick={this.closeEditModal.bind(this, selectedSubscriber)}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const withAllSubscribersQuery = compose(
  graphql(QueryAllSubscribers, {
    options: props => {
      const limit = LINKS_PER_PAGE;
      const nextToken = props.pageTokens[props.page];

      return {
        variables: { limit, nextToken },
        fetchPolicy: 'cache-and-network',
      };
    },
    props: ({
      data: { listSubscribers = { subscribers: [] }, nextToken = null },
    }) => ({
      subscribers: listSubscribers.subscribers,
      nextToken: listSubscribers.nextToken,
    }),
  }),
  graphql(MutationDeleteSubscriber, {
    options: {
      refetchQueries: [
        {
          query: QueryAllSubscribers,
        },
      ],
      update: (proxy, { data: { deleteSubscriber } }) => {
        const query = QueryAllSubscribers;
        try {
          const data = proxy.readQuery({
            query,
          });
          const currentSubscribers = data.listSubscribers.subscribers;
          data.listSubscribers.subscribers = currentSubscribers.filter(
            subscriber => subscriber.id !== deleteSubscriber.id,
          );

          proxy.writeQuery({
            query,
            data,
          });
        } catch (error) {}
      },
    },
    props: props => ({
      deleteSubscriber: subscriber => {
        return props.mutate({
          variables: { id: subscriber.id },
          optimisticResponse: () => ({
            deleteSubscriber: {
              ...subscriber,
              __typename: 'Subscriber',
            },
          }),
        });
      },
    }),
  }),
  graphql(MutationEditSubscriber, {
    options: {
      refetchQueries: [
        {
          query: QueryAllSubscribers,
        },
      ],
      update: (proxy, { data: { updateSubscriber } }) => {
        const query = QueryAllSubscribers;
        try {
          const data = proxy.readQuery({
            query,
          });
          const currentSubscribers = data.listSubscribers.subscribers;
          const targetToUpdate = currentSubscribers.find(currentSubscribers => {
            return currentSubscribers.id === updateSubscriber.id;
          });
          data.listSubscribers[targetToUpdate] = updateSubscriber;
          proxy.writeQuery({
            query,
            data,
          });
        } catch (error) {}
      },
    },
    props: props => ({
      updateSubscriber: subscriber => {
        return props.mutate({
          variables: { id: subscriber.id, email: subscriber.email },
          optimisticResponse: () => ({
            updateSubscriber: {
              ...subscriber,
              __typename: 'Subscriber',
            },
          }),
        });
      },
    }),
  }),
);
export default withAllSubscribersQuery(ListSubscribers);



// WEBPACK FOOTER //
// ./src/components/ListSubscribers.js